import MyDepartments from './MyDepartments.gql';

export default MyDepartments;
